import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  newMedicalAppointments,
  showMedicalAppointments,
  editMedicalAppointments,
} from '~/config/routes';

import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

import { MedicalAppointmentsProvider } from './context';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';

function MedicalAppointments() {
  return (
    <MedicalAppointmentsProvider>
      <Switch>
        <Route
          exact
          path={newMedicalAppointments.spec}
          render={(props) => (
            <>
              <Can I="new" a="MedicalAppointments">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="MedicalAppointments">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />

        <Route
          exact
          path={showMedicalAppointments.spec}
          render={(props) => (
            <>
              <Can I="show" a="MedicalAppointments">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="MedicalAppointments">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />

        <Route
          exact
          path={editMedicalAppointments.spec}
          render={(props) => (
            <>
              <Can I="edit" a="MedicalAppointments">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="MedicalAppointments">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />

        <Route
          render={(props) => (
            <>
              <Can I="list" a="MedicalAppointments">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="MedicalAppointments">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </MedicalAppointmentsProvider>
  );
}
export default MedicalAppointments;
